import store from '../../store';
import { beablooApi } from '../../utils';

const updateMetadata = async (payload, activePhase = 0) => {
  const { general: { currentDevelopment } } = store.getState();

  const response = await beablooApi({
    method: 'PUT',
    route: `/developments/${currentDevelopment.id}/metadata/update?phase=${activePhase}`,
    payload,
  });

  if (!response.success) {
    throw new Error(response.message)
  }

  return response.data;
}

const activatePhase = async phaseId => {
  const { general: { currentDevelopment } } = store.getState();

  const response = await beablooApi({
    method: 'PUT',
    route: `/developments/${currentDevelopment.id}/metadata/update`,
    payload: { activePhase: phaseId },
  });

  if (!response.success) {
    throw new Error(response.message)
  }

  return response.data;
}

const createPhase = async payload => {
  const { general: { currentDevelopment } } = store.getState();

  const response = await beablooApi({
    method: 'PUT',
    route: `/developments/${currentDevelopment.id}/metadata/create-phase`,
    payload,
  });

  console.log(response);

  if (!response.success) {
    throw new Error(response.message);
  }

  return response.data;
}

const deletePhase = async phaseId => {
  const { general: { currentDevelopment } } = store.getState();

  const response = await beablooApi({
    method: 'DELETE',
    route: `/developments/${currentDevelopment.id}/metadata/delete-phase/${phaseId}`,
  });

  console.log(response);

  if (!response.success) {
    throw new Error(response.message);
  }

  return response.data;
}

const enablePhases = async (value) => {
  const { general: { currentDevelopment } } = store.getState();

  const response = await beablooApi({
    method: 'PUT',
    route: `/developments/${currentDevelopment.id}/metadata/enable-phase`,
    payload: { phaseEnabled: value },
  });
  console.log(response);
  if (!response.success) {
    throw new Error(response.message);
  }

  return response.data;
}

const metadataService = {
  updateMetadata,
  activatePhase,
  createPhase,
  deletePhase,
  enablePhases
}

export default metadataService;
